export enum EnumRegulatoryReportState {
  Operaciones_pendientes = 1,
  Pendiente = 2,
  Enviado = 3,
}